import React from 'react';

import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import CircularProgress from '@mui/material/CircularProgress';
import Tooltip from '@mui/material/Tooltip';

const ICON_BY_TYPE = {
    project: WorkOutlineIcon,
    folder: FolderOutlinedIcon,
    item: DescriptionOutlinedIcon,
};

const ExpandButton = ({isExpanded, isLoading, onClick, testId}) => {
    if (isLoading) {
        return <CircularProgress size={16} style={{marginRight: 4}} />;
    }
    const Icon = isExpanded ? ExpandMoreIcon : ChevronRightIcon;
    return (
        <Icon
            data-testid={testId}
            onClick={onClick}
            style={{fontSize: 20, cursor: 'pointer', color: 'var(--main-light-color)'}}
        />
    );
};

const TOOLTIP_PROPS = {
    tooltip: {
        className: '!text-base !text-main-normal !bg-background-normal !border !border-panels-normal !shadow-lg !rounded-input',
    },
};

const ContentTreeNode = ({node, nodeType, depth = 0, isExpanded, isLoading, isExpandable = true, renderPrefix, renderSuffix, onExpand, nameClassName, tooltipText, iconOverride}) => {
    const TypeIcon = iconOverride || ICON_BY_TYPE[nodeType] || DescriptionOutlinedIcon;
    const isDisabled = nameClassName?.includes('cursor-not-allowed');

    const row = (
        <div
            data-testid={`access-node-${node.name}`}
            data-disabled={isDisabled || undefined}
            className={`flex items-center py-1.5 pr-1 hover:bg-panels-normal rounded-menu ${isDisabled ? 'cursor-not-allowed' : ''}`}
            style={{paddingLeft: depth * 24 + 8}}
        >
            <div className="flex items-center" style={{width: 24}}>
                {isExpandable && nodeType !== 'item' && (
                    <ExpandButton isExpanded={isExpanded} isLoading={isLoading} onClick={onExpand} testId={`access-expand-${node.name}`} />
                )}
            </div>
            {renderPrefix && renderPrefix()}
            <TypeIcon style={{fontSize: 18, color: 'var(--main-light-color)', marginRight: 6}} />
            <span className={`flex-1 text-sm truncate ${nameClassName || 'text-main-normal'}`}>{node.name}</span>
            {renderSuffix && renderSuffix()}
        </div>
    );

    if (tooltipText) {
        return (
            <Tooltip title={tooltipText} placement="top" enterDelay={300} componentsProps={TOOLTIP_PROPS}>
                {row}
            </Tooltip>
        );
    }

    return row;
};

export default ContentTreeNode;
